
import Vue from 'vue'
import CreatFindle from './CreatFindle'
import { CodeRuleServiceProxy } from '@/service-proxies/app-v2/code.service-proxies'
import '../../index.less'
const crsp = new CodeRuleServiceProxy()

export default Vue.extend({
  data(){
    return {
      form: this.$form.createForm(this),
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 14 },
      },
      applicationObjectCode: "",
      findleList: [],
      confirmLoading: false
    }
  },
  components:{
    CreatFindle
  },
  props:{
    objectsList:{
      type: Array,
      default: () => ([])
    },
    visible:{
      type: Boolean,
      default: false
    }
  },
  methods:{
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    handleSave(){
      this.form.validateFields((err,values) => {
        if (!err) {
          const objdct = this.objectsList.find(res => res.applicationObjectCode === values.applicationObject)
          values.applicationObject = objdct.applicationObject
          values.applicationObjectCode = objdct.applicationObjectCode
          values.id = ""
          if(this.findleList === 0){
            this.$message.warning('字段列表不能为空')
            return
          }
          values.fieldList = this.findleList
          this.confirmLoading = true
          crsp.save(values).then(() =>{
            this.$message.success('保存成功')
            this.form.resetFields()
            this.findleList = []
            this.confirmLoading = false
            this.$emit('save')
          }).catch(() =>{
            this.confirmLoading = false
          })
        }
      });
    },
    handleCancel(){
      this.form.resetFields()
      this.findleList = []
      this.$emit('cancel')
    },
    saveFindleList(value){
      this.findleList = []
      value.map((res,index) => res.sort = index + 1)
      this.findleList = value
    },
    changeObject(value){
      this.findleList = []
      this.applicationObjectCode = value
    }
  }
})
